import {
    GET_POSTDISCHARGES_LIST_PENDING,
    GET_POSTDISCHARGES_LIST_FULFILLED,
    GET_POSTDISCHARGES_LIST_REJECTED,
    GET_POSTDISCHARGES_LIST_90D_PENDING,
    GET_POSTDISCHARGES_LIST_90D_FULFILLED,
    GET_POSTDISCHARGES_LIST_90D_REJECTED,
    GET_POSTDISCHARGES_LIST_180D_PENDING,
    GET_POSTDISCHARGES_LIST_180D_FULFILLED,
    GET_POSTDISCHARGES_LIST_180D_REJECTED,
    GET_POSTDISCHARGES_LIST_12M_PENDING,
    GET_POSTDISCHARGES_LIST_12M_FULFILLED,
    GET_POSTDISCHARGES_LIST_12M_REJECTED,
    GET_POSTDISCHARGES_LIST_24M_PENDING,
    GET_POSTDISCHARGES_LIST_24M_FULFILLED,
    GET_POSTDISCHARGES_LIST_24M_REJECTED,
    GET_POSTDISCHARGES_LIST_36M_PENDING,
    GET_POSTDISCHARGES_LIST_36M_FULFILLED,
    GET_POSTDISCHARGES_LIST_36M_REJECTED,
    GET_POSTDISCHARGE_PENDING,
    GET_POSTDISCHARGE_FULFILLED,
    GET_POSTDISCHARGE_REJECTED,
    GET_POSTDISCHARGES_COUNT_FULFILLED,
    ARCHIVE_POSTDISCHARGE_FULFILLED,

    UPDATE_POSTDISCHARGE_SAVE_PENDING,
    UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_PENDING,

    UPDATE_POSTDISCHARGE_SAVE_FULFILLED,
    UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_FULFILLED,
} from '../../actions/action-constants';
const initialState = {
    postdischargeEntry: [],
    postdischarges: [],
    alchoholaftercareprograms: [],
    bop: [],
    drugaftercareprograms: [],
    financialresponsibilityprograms: [],
    gangaffiliations: [],
    institutions: [],
    bopinstitutions: [],
    levelsofsecurity: [],
    referralsources: [],
    count: -1,
    boprrccount: -1,
    opcusptspsycount: -1,
    loadingList: false,
    updateSuccess: false,
    transferSuccess: false,
    archiveSuccess: false,

    dataEntry: {},
    dataList: [],
    
    errorInvalidEntry: false,
    errors: [],
};
const reducerPostDischarges = (state = initialState, action) => {
  var dataEntry;
  var dataList;
  switch (action.type) {
    case GET_POSTDISCHARGE_PENDING:
    case GET_POSTDISCHARGES_LIST_PENDING:
    case GET_POSTDISCHARGES_LIST_90D_PENDING:
    case GET_POSTDISCHARGES_LIST_180D_PENDING:
    case GET_POSTDISCHARGES_LIST_12M_PENDING:
    case GET_POSTDISCHARGES_LIST_24M_PENDING:
    case GET_POSTDISCHARGES_LIST_36M_PENDING:
    case UPDATE_POSTDISCHARGE_SAVE_PENDING:
    case UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_PENDING:
        state = {
            ...state
            , loadingList: true
        };
        break;
    case GET_POSTDISCHARGES_COUNT_FULFILLED:
        var tblcount = -1;
        var boprrccount = -1;
        var opcusptspsycount = -1;

        var postdischarges90d = -1;
        var postdischarges180d = -1;
        var postdischarges12m = -1;
        var postdischarges24m = -1;
        var postdischarges36m = -1;
        dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.postdischargescount[0] : [] ;
        if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {
            tblcount = dataEntry.count;
            boprrccount = dataEntry.boprrccount;
            opcusptspsycount = dataEntry.opcusptspsycount;

            postdischarges90d = dataEntry.postdischarges90d;
            postdischarges180d = dataEntry.postdischarges180d;
            postdischarges12m = dataEntry.postdischarges12m;
            postdischarges24m = dataEntry.postdischarges24m;
            postdischarges36m = dataEntry.postdischarges36m;
        }
        state = {
            ...state,
            loadingList: false,
            addSuccess: false,
            updateSuccess: false,
            deleteSuccess: false,
            transferSuccess: false,
            archiveSuccess: false,
            errorInvalidEntry: false,
            count: tblcount,
            boprrccount: boprrccount,
            opcusptspsycount: opcusptspsycount,

            postdischarges90d,
            postdischarges180d,
            postdischarges12m,
            postdischarges24m,
            postdischarges36m,
                    
        };
        break;
    case GET_POSTDISCHARGES_LIST_FULFILLED:
    case GET_POSTDISCHARGES_LIST_90D_FULFILLED:
    case GET_POSTDISCHARGES_LIST_180D_FULFILLED:
    case GET_POSTDISCHARGES_LIST_12M_FULFILLED:
    case GET_POSTDISCHARGES_LIST_24M_FULFILLED:
    case GET_POSTDISCHARGES_LIST_36M_FULFILLED:
        dataList = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.postdischarges : [] ;
        state = {
            ...state
            , loadingList: false
            , addSuccess: false
            , updateSuccess: false
            , deleteSuccess: false
            , errorInvalidEntry: false
            , dataList: dataList
        };
        break;
    case GET_POSTDISCHARGE_FULFILLED:
        // console.log("77-88-77 data ");
        // console.log(action.payload.data);
        var invalidEntry = false;
        if(action.payload.data.postdischarges.length > 0) {
            dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.postdischarges[0] : [] ;

            if (dataEntry.program === '' || dataEntry.program === null ) {
                dataEntry.program = '1';
            } else {
                dataEntry.program = dataEntry.program.toString();;
            }
            
            if (dataEntry.referraloutcome === '' || dataEntry.referraloutcome === null ) {
                dataEntry.referraloutcome = '1';
            } else {
                dataEntry.referraloutcome = dataEntry.referraloutcome.toString();;
            }
        
            if (dataEntry.clientdischargestatus === '' || dataEntry.clientdischargestatus === null ) {
                dataEntry.clientdischargestatus = '1';
            } else {
                dataEntry.clientdischargestatus = dataEntry.clientdischargestatus.toString();;
            }
        
            if (dataEntry.clientdischargesubstatus === '' || dataEntry.clientdischargesubstatus === null ) {
                dataEntry.clientdischargesubstatus = '1';
            } else {
                dataEntry.clientdischargesubstatus = dataEntry.clientdischargesubstatus.toString();;
            }

        } else {
            dataEntry = {};
            invalidEntry = true;
        }                                                                        
        state = {
            ...state,
            loadingList: false,
            errorInvalidEntry: invalidEntry,
            dataEntry: dataEntry,
            postdischarges: [],
        };
        break;
    case ARCHIVE_POSTDISCHARGE_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , archiveSuccess: true
        };
        break;
    case UPDATE_POSTDISCHARGE_SAVE_FULFILLED:
        state = {
            ...state,
            loadingList: false,
            updateSuccessSave: true,
            updateSuccessSaveAndClose: false,
        };
        break;
    case UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , updateSuccessSave: false
            , updateSuccessSaveAndClose: true
        };
        break;
    case GET_POSTDISCHARGES_LIST_REJECTED:
    case GET_POSTDISCHARGES_LIST_90D_REJECTED:
    case GET_POSTDISCHARGES_LIST_180D_REJECTED:
    case GET_POSTDISCHARGES_LIST_12M_REJECTED:
    case GET_POSTDISCHARGES_LIST_24M_REJECTED:
    case GET_POSTDISCHARGES_LIST_36M_REJECTED:
    case GET_POSTDISCHARGE_REJECTED:
        state = {
            ...state
            , errors: [action.payload.response]
        };
        break;                
    default:
        return state;
  }

  return state;
};

export default reducerPostDischarges;